/** */
import React from 'react';
import { SectionCard } from 'app/shared/section-card';
import { DOMAIN_LABEL } from '../domain-card/config';
import styles from './anomaly-panel.module.css';

const toTitleCase = (str) => str.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const formatMetric = (metric) => toTitleCase(metric);

const formatDescription = (desc) => desc.replace(/\b[a-z][a-z0-9]*(?:_[a-z0-9]+)+\b/g, toTitleCase);

const formatRange = (range) => {
  if (!range) return null;
  const { min, max } = range;
  if (min !== null && min !== undefined && max !== null && max !== undefined)
    return `${min} – ${max}`;
  if (min !== null && min !== undefined) return `≥ ${min}`;
  if (max !== null && max !== undefined) return `≤ ${max}`;
  return null;
};

const formatValue = (val) => {
  if (val === null || val === undefined) return null;
  const n = Number(val);
  if (isNaN(n)) return String(val);
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n % 1 === 0 ? `${n}` : `${n.toFixed(2)}`;
};

export const AnomalyPanel = ({ anomalies = [], loading }) => {
  const critical = anomalies.filter((a) => a.severity === 'critical');
  const warning = anomalies.filter((a) => a.severity === 'warning');
  const sorted = [...critical, ...warning];

  const action =
    anomalies.length > 0 ? (
      <div className={styles.countBadge}>
        {critical.length > 0 && (
          <span className={styles.criticalCount}>{critical.length} critical</span>
        )}
        {warning.length > 0 && (
          <span className={styles.warningCount}>{warning.length} warning</span>
        )}
      </div>
    ) : null;

  return (
    <SectionCard title="Anomalies" action={action}>
      <div className={styles.body}>
        {loading ? (
          <div className={styles.empty}>Loading…</div>
        ) : sorted.length === 0 ? (
          <div className={styles.empty}>No active anomalies</div>
        ) : (
          sorted.map((a, i) => {
            const range = formatRange(a.expected_range);
            const current = formatValue(a.current_value);
            return (
              <div key={i} className={`${styles.item} ${styles[a.severity]}`}>
                <div className={styles.itemHeader}>
                  <span className={`${styles.severityDot} ${styles[`dot_${a.severity}`]}`} />
                  <span className={styles.domain}>{DOMAIN_LABEL[a.domain] || a.domain}</span>
                  <span className={styles.metric}>{formatMetric(a.metric)}</span>
                </div>
                <div className={styles.description}>{formatDescription(a.description)}</div>
                {(current || range) && (
                  <div className={styles.meta}>
                    {current && (
                      <span>
                        Current: <strong>{current}</strong>
                      </span>
                    )}
                    {range && (
                      <span>
                        Expected: <strong>{range}</strong>
                      </span>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </SectionCard>
  );
};
